<common-checkbox variant="primary" [ngModel]="significance" (ngModelChange)="onOptionalChanged($event)">
  {{ 'Optional' | transloco }}
</common-checkbox>

@if (!hidePreference) {
  <common-checkbox
    class="preference-toggle"
    variant="primary"
    [ngModel]="preferredOptionOrder"
    (ngModelChange)="onPreferredOptionChanged($event)">
    {{ 'PreferredTreatmentOption' | transloco }}
  </common-checkbox>
}
